import React, { useState, useEffect } from "react";
import { FiEdit3 } from "react-icons/fi";
import styles from "../../../styles/CompanyManagement/CompanyDetails.module.css";
import axiosInstance from "../../../utils/api";
import { FaInstagram, FaFacebookF, FaXTwitter, FaYoutube } from 'react-icons/fa6';

const socialFields = [
  { label: "Instagram", name: "instagram" },
  { label: "Facebook", name: "facebook" },
  { label: "X", name: "x" },
  { label: "YouTube", name: "youtube" },
];

const iconMap = {
  instagram: <FaInstagram className={styles.socialMediaIconInstagram} />,
  facebook: <FaFacebookF className={styles.socialMediaIconFacebook} />,
  x: <FaXTwitter className={styles.socialMediaIconX} />,
  youtube: <FaYoutube className={styles.socialMediaIconYoutube} />,
};

const Socials = ({ companyId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (!companyId) return;
    axiosInstance.get(`/api/v1/companies/${companyId}`)
      .then(res => {
        const socials = res.data.additional_infos?.socials || {};
        setFormData({
          ...socialFields.reduce((acc, f) => ({ ...acc, [f.name]: socials[f.name] || "" }), {})
        });
      });
  }, [companyId]);

  const handleEditClick = () => setIsEditing(true);
  const handleSaveClick = async () => {
    if (!companyId) return;
    // Fetch the latest additional_infos to avoid overwriting other sections
    const res = await axiosInstance.get(`/api/v1/companies/${companyId}`);
    const existing = res.data.additional_infos || {};
    const socialsData = socialFields.reduce((acc, f) => ({ ...acc, [f.name]: formData[f.name] || "" }), {});
    await axiosInstance.patch(`/api/v1/companies/${companyId}`, {
      company: {
        additional_infos: {
          ...existing,
          socials: socialsData
        }
      }
    });
    setIsEditing(false);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>Socials</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      <div className={styles.socialMediaList}>
        {socialFields.map((item) => (
          <div key={item.name} className={styles.socialMediaItem}>
            <span className={styles.iconSpan}>{iconMap[item.name]}</span>
            <div>
              <p className={styles.socialMediaText}>{item.label}</p>
              {isEditing ? (
                <input
                  type="text"
                  name={item.name}
                  value={formData[item.name] || ""}
                  onChange={handleChange}
                  placeholder={`Enter ${item.label} link or handle`}
                />
              ) : (
                <p className={styles.socialMediaDescription}>{formData[item.name]}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Socials;
